import { render } from "./MarkdownEditor.vue?vue&type=template&id=779218c4&scoped=true"
import script from "./MarkdownEditor.vue?vue&type=script&lang=js"
export * from "./MarkdownEditor.vue?vue&type=script&lang=js"

import "./MarkdownEditor.vue?vue&type=style&index=0&id=779218c4&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779218c4"]])

export default __exports__